import { auxiliaryStorage } from "./auxiliaryStorage";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@hanjan-shieo/ui/tokens.css";
import "./styles.css";
import "./uplift.css";
import "./meetup.css";
import { App } from "./App";
import { channel } from "./channel";
import { installProductStorage } from "./storage";
import { installChannelHaptic } from "./platform";

async function start() {
  if (channel === "ait") {
    // Install before the first read. Failed bridge calls remain visible storage errors;
    // never silently write a second copy to browser localStorage.
    const { Storage, Device } = await import("@apps-in-toss/web-framework");
    installProductStorage(Storage);
    installChannelHaptic((pattern) => { void Device.triggerHaptic({ type: Array.isArray(pattern) ? "success" : pattern === 20 ? "tickMedium" : "tickWeak" }).catch(() => undefined); return true; });
    const { installTossNavigation } = await import("./tossNavigation");
    installTossNavigation();
  }
  await auxiliaryStorage.hydrate();
  createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
}
void start().catch(() => {
  const root = document.getElementById("root")!;
  const message = document.createElement("p");
  message.textContent = "게임을 열지 못했어요. 저장된 기록은 그대로 있어요.";
  const retry = document.createElement("button");
  retry.textContent = "다시 열기";
  retry.onclick = () => location.reload();
  root.replaceChildren(message, retry);
});

if ((globalThis as { Capacitor?:{ isNativePlatform?:() => boolean } }).Capacitor?.isNativePlatform?.()) {
  void import("./nativePlatform").then(({ installNativePlatform }) => installNativePlatform());
}
